// Absolute origin of the default workspace ("app"), used for cross-subdomain
// links from the marketing site (the root domain has no workspace of its
// own). Mirrors the `https://<subdomain>.<rootDomain>` convention already
// used in Navigation/WorkspaceSwitcher; like it, it does not handle the
// scheme or port for local dev (app.lvh.me:3000).
export function appOrigin(): string {
  return `https://app.${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`
}

// Absolute origin of the public marketing site - the bare root domain,
// canonical home of "/" and the legal pages ("/terms/*"). Link legal
// content here from anywhere (workspace subdomains included) so it has a
// single URL. Same scheme/port caveat as appOrigin().
export function marketingOrigin(): string {
  return `https://${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`
}
